  const connectionFun = function () {
    let msgConnection;
    let pasConnection = null;
    let pasTimer = null,msgTimer = null;
    this.msgConnect = function (signalR, options) {
      console.log('msgConnection')
      if(msgConnection){
        msgConnection.stop();
        msgConnection = '';
      }
      msgConnection = new signalR.HubConnectionBuilder().withUrl(options.signalrPath + "/messageClient?ServerToken=" + options.userId + "&AppKey=Ultimo.Essential",{ accessTokenFactory: () => options.token.replace('Bearer ','') }).build();
      msgConnection.on('ReceiveMessage', function (message) {
        options.receiveMessage(message);
      });
      /*监控区域统计实时刷新*/
      msgConnection.on('MonitoringAreaPeopeleCountChange', function (message) {
        options.monitoringAreaPeopeleCountChange(message);
      });
      msgConnection.on('EsopAlarmRefresh', function (message) {
        options.EsopAlarmRefresh(message);
      });
      msgConnection.on('EsopTaskStatusChanged', function (message) {
        options.EsopTaskStatusChanged(message);
      });
      msgConnection.on('EsopAlarmClosed', function (message) {
        options.EsopAlarmClosed(message);
      });
      msgConnection.start().catch(function (err) {
        console.log('连接失败');
      });
      msgConnection.on('UpdateIncidentRecordLevel', function (message) {
        options.UpdateIncidentRecordLevel(message);
      });

      //发起人结束会议，接听发挂断电话
      msgConnection.on('SipNotification', function (message) {
        options.closeCall(message);
      });

      //喊话广播时，被人终止，主动挂
      msgConnection.on('BroadCastClosed', function (message) {
        console.log(message);
        options.closeCall(message); 
      });
      async function start() {
        clearTimeout(msgTimer);
        try {
          console.log('尝试重连...');
          await msgConnection.start();
          console.log('已重连');
        } catch (err) {
          console.log('重连失败');
          msgTimer = setTimeout(() => start(), 2000);
        }
      }
      msgConnection.onclose(async () => {
        if(msgConnection){
          await start();
        }
      });
    };

    // passport刷卡连接
    this.passportReader = function () {
      let _this = this;
      try {
        let host = 'ws://127.0.0.1:90/echo'; // http 访问方式
        pasConnection = new WebSocket(host);
        if (pasConnection !== null) {
          pasConnection.onopen = function () {
            console.log('Passport Reader Connect Success')
          };
          pasConnection.onclose = function () {
            if (pasConnection != null) {
              pasTimer = setTimeout(function () {
                clearTimeout(pasTimer);
                _this.passportReader();
              }, 2000)
            }
          };
          pasConnection.onerror = function () {
            console.log('Passport Reader Connect Failure');
          };
          pasConnection.onmessage = function (event) {
            try {
              let data = JSON.parse(event.data);
              window.eventBus.$emit('openRegistration', data);
            } catch (exception) {}
          }
        }
      } catch (exception) {}
    };

    this.destroy = function(){//停止Signalr链接
      if(msgConnection){
        clearTimeout(msgTimer);
        msgConnection.stop();
        msgConnection = '';
      }
      if(pasConnection){
        clearTimeout(pasTimer);
        pasConnection.close();
        pasConnection = null;
      }
    }
  };
const connect = new connectionFun();
export default connect;





//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/js/notification.js
// module id = 7Wf1
// module chunks = 15